module.exports = __webpack_public_path__ + "static/media/6.3174b999.png";